'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_home', {
    url: '/home',
    template: '<oem-home></oem-home>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem_home/oem_home.routes.js